<div class="container">
  <div class="page mat-elevation-z8">
    <img class="image" [src]="getPageImage()" (click)="gotoPage()">
    <div class="details">
      <span class="page-number">{{pageNumber}}</span>
      <div class="actions">
        <mat-icon *ngIf="features.download"
                  (click)="download()"
                  matTooltip="Download"
                  i18n-matTooltip="@@actionDownload">file_download</mat-icon>
        <mat-icon *ngIf="features.bookmarks"
                  [class.active]="isBookmarked"
                  (click)="bookmark()"
                  matTooltip="{{'bookmarks-tooltip' | translate}}"
                  i18n-matTooltip="@@bookmarks">bookmark</mat-icon>
        <mat-icon *ngIf="features.notes"
                  [class.active]="hasNote"
                  (click)="note()"
                  matTooltip="{{'notes-tooltip' | translate}}"
                  i18n-matTooltip="@@notes">comment</mat-icon>
      </div>
    </div>
  </div>
  <div *ngIf="fullWidth" class="note">{{pageNote}}</div>
</div>
